// Build metadata compiled INTO the JS bundle at build time by vite.config.js's
// `define` block (see __APP_VERSION__ / __BUILD_SHA__ / __BUILD_TIME__ there).
// Because the bundle is cached and served by the service worker, the values a
// user sees ARE the values of the build their cache is running — so a support
// tester can read the stamp off the /me page and know exactly which (possibly
// stale) build that device loaded. This diagnoses the stale-service-worker
// problem where a tester is stuck on an old cached build with no other tell.
//
// The `typeof … !== 'undefined'` guards let this module load unchanged under
// Vitest, whose config has no `define` (the identifiers stay undeclared there,
// so a bare reference would throw). At real build time esbuild textually
// replaces each identifier with a string literal, so these fold to constants.

/* global __APP_VERSION__ __BUILD_SHA__ __BUILD_TIME__ __BUILD_NUMBER__ */

export const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'
export const sha = typeof __BUILD_SHA__ !== 'undefined' ? __BUILD_SHA__ : 'dev'
export const date = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : ''
// buildNumber: monotonic per-publish counter (git commit count) injected at
// build time. Falls back to 'dev' under Vitest (no `define`) and in non-git
// build environments — same pattern as version/sha above.
export const buildNumber = typeof __BUILD_NUMBER__ !== 'undefined' ? __BUILD_NUMBER__ : 'dev'

// Human-readable app version label for the Profile/Me page: major.minor ONLY
// (e.g. "3.2.0" -> "v3.2"), the patch is intentionally dropped. Owner-facing
// version checks must expect this shape — a checklist that said "v3.2.0" was a
// guaranteed false-negative (F-009-T8 review) because the page never renders
// the patch segment. Kept OUT of the default export so the buildInfo object
// stays a pure {version, sha, date, buildNumber} bag.
export function appVersionLabel(v = version) {
  return `v${String(v).split('.').slice(0, 2).join('.')}`
}

export default { version, sha, date, buildNumber }
